<template>
  <div class="flex flex-col pt-9 pb-52 bg-white min-h-[600px]">
    <BreadCrumb text="主页/联系我们"></BreadCrumb>
    <SectionBar text="联系我们"></SectionBar>

    <div class="flex flex-col items-center mt-16 w-full max-md:mt-10 max-md:max-w-full">
      <div class="flex flex-col w-11/12 max-md:ml-0 max-md:w-full">
        <div
          class="flex flex-col grow px-8 py-12 w-full whitespace-nowrap rounded-lg bg-zinc-100 max-md:px-5 max-md:mt-10 max-md:max-w-full">
          <div class="font-semibold text-black text-4xl mb-6 mt-1 max-md:mt-10">总部</div>
          <div class="text-black text-xl mb-6 mt-1 max-md:mt-10">深圳市瑜威电子科技有限公司</div>
          <div class="text-black text-xl mb-6 mt-1 max-md:mt-10">地址：深圳市南山区粤海街道高新区社区深南大道9789号德赛科技大厦1904A</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import SectionBar from '@/components/SectionBar.vue';
import BreadCrumb from '@/components/BreadCrumb.vue';

export default {
  name: 'AboutPage',
  components: {
    SectionBar,
    BreadCrumb,
  }

};
</script>